import '../scss/shop.kfzteile24.scss';

import '../js/shop.js';
